import { useMutation, useQuery, useQueryClient } from "react-query";
import { HttpBaseRequest } from "../../../core/HttpRequest";
import { useToast } from "../../../context/toast/ToastContext";
import {
  addExpense,
  deleteExpense,
  getDetailExpense,
  getListExpense,
  updateExpense,
} from "./service";

export const useGetListExpense = ({
  keyword,
  expense_category_id,
  date_from,
  date_to,
  page,
  perPage,
}: HttpBaseRequest<{
  expense_category_id?: string;
  date_from?: string;
  date_to?: string;
}>) => {
  return useQuery({
    queryKey: [
      "list-expense",
      keyword,
      expense_category_id,
      date_from,
      date_to,
      page,
      perPage,
    ],
    queryFn: () =>
      getListExpense({
        keyword,
        expense_category_id,
        date_from,
        date_to,
        page,
        perPage,
      }),
  });
};

export const useGetDetailExpense = ({
  expense_id,
}: HttpBaseRequest<{ expense_id: string }>) => {
  return useQuery({
    queryKey: ["detail-expense", expense_id],
    queryFn: () => getDetailExpense({ expense_id }),
  });
};

export const useAddExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      name,
      description,
      expense_category_id,
      date,
      total_expense,
      is_using_ppn,
      ppn_expense_category_id,
      ppn_percentage,
    }: {
      name: string;
      expense_category_id: string;
      description: string;
      total_expense: string;
      date: string;
      is_using_ppn?: boolean;
      ppn_expense_category_id?: number;
      ppn_percentage?: number;
    }) =>
      addExpense({
        name,
        description,
        expense_category_id,
        date,
        total_expense,
        is_using_ppn,
        ppn_expense_category_id,
        ppn_percentage,
      }),
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil menambahkan Expense baru");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};

export const useUpdateExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      expense_id,
      name,
      description,
      expense_category_id,
      date,
      total_expense,
      is_using_ppn,
      ppn_expense_category_id,
      ppn_percentage,
    }: {
      expense_id: string;
      name: string;
      expense_category_id: string;
      description: string;
      total_expense: string;
      date: string;
      is_using_ppn?: boolean;
      ppn_expense_category_id?: number;
      ppn_percentage?: number;
    }) =>
      updateExpense({
        expense_id,
        name,
        description,
        expense_category_id,
        date,
        total_expense,
        is_using_ppn,
        ppn_expense_category_id,
        ppn_percentage,
      }),
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil update Expense");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};

export const useDeleteExpense = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ expense_id }: HttpBaseRequest<{ expense_id: string }>) => {
      return deleteExpense({
        expense_id: expense_id,
      });
    },
    onSuccess: (e) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil delete Expense");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};
